import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, SpaceBetween, TextLabel } from "@opensea/ui-kit";
const isActionProps = props => {
  return props.action !== undefined;
};
export function ExpandedSearchSection(props) {
  const $ = _c(22);
  let children;
  let heading;
  let headingClassName;
  let rest;
  if ($[0] !== props) {
    ({
      heading,
      headingClassName,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = heading;
    $[3] = headingClassName;
    $[4] = rest;
  } else {
    children = $[1];
    heading = $[2];
    headingClassName = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] !== headingClassName) {
    t0 = classNames("leading-normal text-text-secondary mb-2", headingClassName);
    $[5] = headingClassName;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== t0) {
    t1 = {
      size: "sm",
      className: t0
    };
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const labelProps = t1;
  const t2 = rest["data-testid"];
  let t3;
  if ($[9] !== heading || $[10] !== labelProps) {
    t3 = <TextLabel {...labelProps}>{heading}</TextLabel>;
    $[9] = heading;
    $[10] = labelProps;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== labelProps || $[13] !== props) {
    t4 = isActionProps(props) ? <TextLabel {...labelProps} className={classNames(labelProps.className, "cursor-pointer text-blue-3 opacity-100")} onClick={props.onActionClick}>{props.action}</TextLabel> : null;
    $[12] = labelProps;
    $[13] = props;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <SpaceBetween>{t3}{t4}</SpaceBetween>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== children || $[19] !== t2 || $[20] !== t5) {
    t6 = <FlexColumn data-testid={t2}>{t5}{children}</FlexColumn>;
    $[18] = children;
    $[19] = t2;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}